import { useMemo } from "react";
import { useGetRateCardQuery } from "./useGetRateCardQuery";

/**
 * Fetches a single rate card (with items) and returns a template-id → unit map.
 * Rate items embed an IDatabaseLineItem under `lineItemTemplate`, so units are
 * keyed by that template's id — which is what persisted line items store as
 * their `lineItemId`.
 */
export function useRateCardUnitByTemplateId(rateCardId: string | undefined) {
  const query = useGetRateCardQuery(rateCardId);

  const map = useMemo(() => {
    const record: Record<string, string> = {};
    if (!query.data) return record;
    for (const item of query.data.items ?? []) {
      const templateId = item.lineItemTemplate?.id;
      if (templateId && item.unit) {
        record[templateId] = item.unit;
      }
    }
    return record;
  }, [query.data]);

  return { unitByTemplateId: map, isLoading: query.isLoading };
}
